// Maps every illustration export name to a lazy module loader so illustrations can be loaded dynamically,
// without bundling all illustrations into the importing bundle.
// Add an entry here when you add a new illustration that will be loaded dynamically with
// `loadIllustrationComponent(illustrationName)`

export type IllustrationLoadersKeys = keyof typeof IllustrationLoaders

export const IllustrationLoaders = {
  AssessmentIcon: () => import('./AssessmentIcon'),
  AuroraAppSpotIllustration: () => import('./AuroraAppSpotIllustration'),
  AuroraCareNavigatorSpotIllustration: () => import('./AuroraCareNavigatorSpotIllustration'),
  AuroraCareSessionsSpotIllustration: () => import('./AuroraCareSessionsSpotIllustration'),
  AuroraCaregiverTrainingForNeuroSecondaryRecIllustration: () =>
    import('./AuroraCaregiverTrainingForNeuroSecondaryRecIllustration'),
  AuroraClinicalLeaveEvaluationSpotIllustration: () => import('./AuroraClinicalLeaveEvaluationSpotIllustration'),
  AuroraCoachingSecondaryRecIllustration: () => import('./AuroraCoachingSecondaryRecIllustration'),
  AuroraCoachingSpotIllustration: () => import('./AuroraCoachingSpotIllustration'),
  AuroraControlledMedsSecondaryRecIllustration: () => import('./AuroraControlledMedsSecondaryRecIllustration'),
  AuroraControlledMedsSpotIllustration: () => import('./AuroraControlledMedsSpotIllustration'),
  AuroraCouplesAndFamilyTherapySpotIllustration: () => import('./AuroraCouplesAndFamilyTherapySpotIllustration'),
  AuroraCouplesTherapySecondaryRecIllustration: () => import('./AuroraCouplesTherapySecondaryRecIllustration'),
  AuroraEmployerBenefitsSpotIllustration: () => import('./AuroraEmployerBenefitsSpotIllustration'),
  AuroraFamilyTherapySecondaryRecIllustration: () => import('./AuroraFamilyTherapySecondaryRecIllustration'),
  AuroraGuidedSelfCareSecondaryRecIllustration: () => import('./AuroraGuidedSelfCareSecondaryRecIllustration'),
  AuroraIndividualTherapySecondaryRecIllustration: () => import('./AuroraIndividualTherapySecondaryRecIllustration'),
  AuroraIndividualTherapySpotIllustration: () => import('./AuroraIndividualTherapySpotIllustration'),
  AuroraMedicationConsultationSecondaryRecIllustration: () =>
    import('./AuroraMedicationConsultationSecondaryRecIllustration'),
  AuroraMedicationManagementSpotIllustration: () => import('./AuroraMedicationManagementSpotIllustration'),
  AuroraNeurodiversitySkillsCoachingSecondaryRecIllustration: () =>
    import('./AuroraNeurodiversitySkillsCoachingSecondaryRecIllustration'),
  AuroraNeuropsychologicalEvaluationsSecondaryRecIllustration: () =>
    import('./AuroraNeuropsychologicalEvaluationsSecondaryRecIllustration'),
  AuroraRenewSecondaryRecIllustration: () => import('./AuroraRenewSecondaryRecIllustration'),
  AuroraOutPatientSupportSpotIllustration: () => import('./AuroraOutPatientSupportSpotIllustration'),
  AuroraParentCoachingSpotIllustration: () => import('./AuroraParentCoachingSpotIllustration'),
  AuroraPreferencesEntrypointIllustration: () => import('./AuroraPreferencesEntrypointIllustration'),
  AuroraSelfCareEssentialsSpotIllustration: () => import('./AuroraSelfCareEssentialsSpotIllustration'),
  AuroraSelfCareResourcesSpotIllustration: () => import('./AuroraSelfCareResourcesSpotIllustration'),
  AuroraSupportForNeurodiversitySecondaryRecIllustration: () =>
    import('./AuroraSupportForNeurodiversitySecondaryRecIllustration'),
  AuroraWorkplaceWellbeingSpotIllustration: () => import('./AuroraWorkplaceWellbeingSpotIllustration'),
  CareOptionCouplesAndFamilyTherapyIcon: () => import('./CareOptionCouplesAndFamilyTherapyIcon'),
  CareOptionParentingSupportIcon: () => import('./CareOptionParentingSupportIcon'),
  ProviderIdentityIllustration: () => import('./ProviderIdentityIllustration'),
  StressIllustration: () => import('./StressIllustration'),
  DepressionIllustration: () => import('./DepressionIllustration'),
  AnxietyIllustration: () => import('./AnxietyIllustration'),
  RelationshipFamilyIllustration: () => import('./RelationshipFamilyIllustration'),
  DrinkingUsingIllustration: () => import('./DrinkingUsingIllustration'),
  MiscellaneousIllustration: () => import('./MiscellaneousIllustration'),
  SocialProblemsIllustration: () => import('./SocialProblemsIllustration'),
  ProblemsFocusingIllustration: () => import('./ProblemsFocusingIllustration'),
  BehaviorProblemsIllustration: () => import('./BehaviorProblemsIllustration'),
  AutismIllustration: () => import('./AutismIllustration'),
  DevelopmentalDelaysIllustration: () => import('./DevelopmentalDelaysIllustration'),
  ContactCNIllustration: () => import('./ContactCNIllustration'),
  BookSessionsIcon: () => import('../icons/BookSessionsIcon'),
  PracticeSkillsIcon: () => import('../icons/PracticeSkillsIcon'),
  ProgressIcon: () => import('../icons/ProgressIcon'),
  Family: () => import('./Family'),
  MemberPreferenceLGBTQIAIllustrationIcon: () => import('./MemberPreferenceLGBTQIAIllustrationIcon'),
  MemberPreferencesAvailabilityIllustrationIcon: () => import('./MemberPreferencesAvailabilityIllustrationIcon'),
  MemberPreferencesGenderIllustrationIcon: () => import('./MemberPreferencesGenderIllustrationIcon'),
  MemberPreferencesMeetingSettingIllustrationIcon: () => import('./MemberPreferencesMeetingSettingIllustrationIcon'),
  MemberPreferencesRaceEthnicityIllustrationIcon: () => import('./MemberPreferencesRaceEthnicityIllustrationIcon'),
  MemberPreferencesReligionIllustrationIcon: () => import('./MemberPreferencesReligionIllustrationIcon'),
  MemberPreferencesVeteransIllustrationIcon: () => import('./MemberPreferencesVeteransIllustrationIcon'),
  ExerciseIcon: () => import('./ExerciseIcon'),
  InfoSheetIcon: () => import('./InfoSheetIcon'),
  LessonIcon: () => import('./LessonIcon'),
  GraduationIcon: () => import('./GraduationIcon'),
  DisclaimerIllustration: () => import('./DisclaimerIllustration'),
  WaitingRoom: () => import('./WaitingRoom'),
  CareTeamIllustration: () => import('./CareTeamIllustration'),
  ProviderMatchingIllustration: () => import('./ProviderMatchingIllustration'),
  CalendarIllustration: () => import('./CalendarIllustration'),
  Meds: () => import('./Meds'),
  HighFiveIllustration: () => import('./HighFiveIllustration'),
  ButterflyAndFlowerIllustration: () => import('./ButterflyAndFlowerIllustration'),
  ChildProfilesIllustration: () => import('./ChildProfilesIllustration'),
  CreditCardIllustration: () => import('./CreditCardIllustration'),
  GlobeTextBubbleIllustration: () => import('./GlobeTextBubbleIllustration'),
  RestingCatIllustration: () => import('./RestingCatIllustration'),
  HealthPlanIllustration: () => import('./HealthPlanIllustration'),
  PaymentIllustration: () => import('./PaymentIllustration'),
  ContactUsSuccessIllustration: () => import('./ContactUsSuccessIllustration'),
  CheckEmailIllustration: () => import('./CheckEmailIllustration'),
  CheckEmailAnimation: () => import('./CheckEmailAnimation'),
  TimeoutIllustration: () => import('./TimeoutIllustration'),
  PrivacyIllustration: () => import('./PrivacyIllustration'),
  SharePreferencesIcon: () => import('./SharePreferencesIcon'),
  PhoneCallIllustrationIcon: () => import('./PhoneCallIllustrationIcon'),
  EmailIllustrationIcon: () => import('./EmailIllustrationIcon'),
  LiveChatIllustrationIcon: () => import('./LiveChatIllustrationIcon'),
  CareNavigatorCalendarIconIllustration: () => import('./CareNavigatorCalendarIconIllustration'),
  FAQIllustrationIcon: () => import('./FAQIllustrationIcon'),
  FAQIllustrationNoBackgroundSvg: () => import('./FAQIllustrationNoBackgroundSvg'),
  CalendarIllustrationAngled: () => import('./CalendarIllustrationAngled'),
  GetPersonalizedGuidanceIllustrationIcon: () => import('./GetPersonalizedGuidanceIllustrationIcon'),
  ExploreOptionsIllustrationIcon: () => import('./ExploreOptionsIllustrationIcon'),
  SelfCareIllustration: () => import('./SelfCareIllustration'),
  HeadphonesSelfCareIllustration: () => import('./HeadphonesSelfCareIllustration'),
  ProviderLedIllustration: () => import('./ProviderLedIllustration'),
  CalendarNoOpenSpotsIllustration: () => import('./CalendarNoOpenSpotsIllustration'),
  MedsPairingSpotIllustration: () => import('./MedsPairingSpotIllustration'),
  KeyboardNavArrow: () => import('./KeyboardNavArrow'),
  PastSessionsIcon: () => import('./PastSessionsIcon'),
  SessionsIcon: () => import('./SessionsIcon'),
  EssentialsOnboardingIcon: () => import('./EssentialsOnboardingIcon'),
  CareTeamAltIllustration: () => import('./CareTeamAltIllustration'),
  WelcomeHome: () => import('./WelcomeHome'),
  WelcomeBeach: () => import('./WelcomeBeach'),
  WelcomePark: () => import('./WelcomePark'),
  CheckListIllustration: () => import('./CheckListIllustration'),
  ActivityOnboardingIcon: () => import('./ActivityOnboardingIcon'),
  CalendarOpenSpotsIllustration: () => import('./CalendarOpenSpotsIllustration'),
  EmptyActivity: () => import('./EmptyActivity'),
  LCTReminderBannerIllustration: () => import('./LCTReminderBannerIllustration'),
  MedicationConsultationIllustration: () => import('./MedicationConsultationIllustration'),
  MessageOnboardingIcon: () => import('./MessageOnboardingIcon'),
  ModalityQuestionnaireDrivingIllustration: () => import('./ModalityQuestionnaireDrivingIllustration'),
  ModalityQuestionnaireUserLaptopIllustration: () => import('./ModalityQuestionnaireUserLaptopIllustration'),
  ProfileOnboardingIcon: () => import('./ProfileOnboardingIcon'),
  ProviderPreferencePersonalization: () => import('./ProviderPreferencePersonalization'),
  RequestCareTeamIllustration: () => import('./RequestCareTeamIllustration'),
  RibbonHeartIllustration: () => import('./RibbonHeartIllustration'),
  S4CLoadingAnimation: () => import('./S4CLoadingAnimation'),
  SessionOnboardingIcon: () => import('./SessionOnboardingIcon'),
  VisitWebsiteIllustration: () => import('./VisitWebsiteIllustration'),
  IndividualTherapySpotIllustrationWhiteBorder: () => import('./IndividualTherapySpotIllustrationWhiteBorder'),
  CareForChildOrTeenSpotIllustration: () => import('./CareForChildOrTeenSpotIllustration'),
  ComplexCareSpotIllustration: () => import('./ComplexCareSpotIllustration'),
  NicotineQuitlineIllustration: () => import('./NicotineQuitlineIllustration'),
  SupportForSelfHarmSpotIllustration: () => import('./SupportForSelfHarmSpotIllustration'),
  InPatientHospitalizationSpotIllustration: () => import('./InPatientHospitalizationSpotIllustration'),
  IntensiveOutpatientSpotIllustration: () => import('./IntensiveOutpatientSpotIllustration'),
  PartialHospitalizationSpotIllustration: () => import('./PartialHospitalizationSpotIllustration'),
  ResidentialTreatmentSpotIllustration: () => import('./ResidentialTreatmentSpotIllustration'),
  CouplesAndFamilyTherapySpotIllustration: () => import('./CouplesAndFamilyTherapySpotIllustration'),
  CoachingSpotIllustration: () => import('./CoachingSpotIllustration'),
  ParentCoachingSpotIllustration: () => import('./ParentCoachingSpotIllustration'),
  SelfCareEssentialsSpotIllustrationWhiteBorder: () => import('./SelfCareEssentialsSpotIllustrationWhiteBorder'),
  OutPatientSupportSpotIllustrationWhiteBorder: () => import('./OutPatientSupportSpotIllustrationWhiteBorder'),
  MedicationManagementSpotIllustration: () => import('./MedicationManagementSpotIllustration'),
  EmployerBenefitsSpotIllustrationWhiteBorder: () => import('./EmployerBenefitsSpotIllustrationWhiteBorder'),
  WorkplaceWellbeingSpotIllustrationWhiteBorder: () => import('./WorkplaceWellbeingSpotIllustrationWhiteBorder'),
  LyraMobileAppSpotIllustration: () => import('./LyraMobileAppSpotIllustration'),
  AppleIcon: () => import('./AppleIcon'),
  ChildCounsellingRec: () => import('./ChildCounsellingRec'),
  ChildMedsRec: () => import('./ChildMedsRec'),
  ClipboardSpotIllustration: () => import('./ClipboardSpotIllustration'),
  YouthTherapyRec: () => import('./YouthTherapyRec'),
  ClinicalScreenerIllustration: () => import('./ClinicalScreenerIllustration'),
  CounsellingRec: () => import('./CounsellingRec'),
  ForkedTriageMainCareOptionIllustration: () => import('./ForkedTriageMainCareOptionIllustration'),
  GoogleIcon: () => import('./GoogleIcon'),
  MedsRec: () => import('./MedsRec'),
  RegistrationEnhancementIllustration: () => import('./RegistrationEnhancementIllustration'),
  TeenTherapyRec: () => import('./TeenTherapyRec'),
  TherapyRec: () => import('./TherapyRec'),
  CoachingRec: () => import('./CoachingRec'),
  RenewRec: () => import('./RenewRec'),
  MeetWithProviderBenefitIllustration: () => import('./MeetWithProviderBenefitIllustration'),
  SelfCareBenefitIllustration: () => import('./SelfCareBenefitIllustration'),
  LyraAppBenefitIllustration: () => import('./LyraAppBenefitIllustration'),
  NotificationIllustration: () => import('./NotificationIllustration'),
  LyraHubBenefitIllustration: () => import('./LyraHubBenefitIllustration'),
  TherapySecondaryRec: () => import('./TherapySecondaryRec'),
  CoachingSecondaryRec: () => import('./CoachingSecondaryRec'),
  RenewSecondaryRec: () => import('./RenewSecondaryRec'),
  MedsConsultationSecondaryRec: () => import('./MedsConsultationSecondaryRec'),
  ControlledMedsSecondaryRec: () => import('./ControlledMedsSecondaryRec'),
  CouplesTherapySecondaryRec: () => import('./CouplesTherapySecondaryRec'),
  FamilyTherapySecondaryRec: () => import('./FamilyTherapySecondaryRec'),
  GuidedSelfCareSecondaryRec: () => import('./GuidedSelfCareSecondaryRec'),
  CoachingForParentsSecondaryRec: () => import('./CoachingForParentsSecondaryRec'),
  SearchForCareRotatingProvidersLottie: () => import('./SearchForCareFindAProviderHomebaseIllustration'),
  ProfileBookingShortTermDisabilityEvaluationIllustration: () =>
    import('./ProfileBookingShortTermDisabilityEvaluationIllustration'),
  FamilyIllustration: () => import('./FamilyIllustration'),
  IntegratedBenefitsMinimizedIllustration: () => import('./IntegratedBenefitsMinimizedIllustration'),
  BallotIllustration: () => import('./BallotIllustration'),
  MobileAppQRCode: () => import('./MobileAppQRCode'),
  MobileAppPromoIllustration: () => import('./MobileAppPromoIllustration'),
  ValuePropMentalHealthSessions: () => import('././ValuePropMentalHealthSessions.web'),
  ValuePropMeditationsCoursesArticles: () => import('./ValuePropMeditationsCoursesArticles.web'),
  ValuePropDedicatedSupport: () => import('./ValuePropDedicatedSupport.web'),
  ValuePropProvidersIntelligentlyMatched: () => import('./ValuePropProvidersIntelligentlyMatched.web'),
  ValuePropOnDemand: () => import('./ValuePropOnDemand.web'),
  WellnessCheckInOverviewIllustration: () => import('./WellnessCheckInOverviewIllustration'),
  PermissionsIllustration: () => import('./PermissionsIllustration'),
  MoodAndEmotionsIllustration: () => import('./MoodAndEmotionsIllustration'),
  ResilienceAndCopingIllustration: () => import('./ResilienceAndCopingIllustration'),
  RolesAndRelationshipsIllustration: () => import('./RolesAndRelationshipsIllustration'),
  PhysicalHealthAndActivityIllustration: () => import('./PhysicalHealthAndActivityIllustration'),
  FinancesAndWorkIllustration: () => import('./FinancesAndWorkIllustration'),
  SpiritualityAndExplorationIllustration: () => import('./SpiritualityAndExplorationIllustration'),
  YellowLightbulbIllustration: () => import('./YellowLightbulbIllustration'),
  ThumbsUpIllustration: () => import('./ThumbsUpIllustration'),
  ThumbsDownIllustration: () => import('./ThumbsDownIllustration'),
  TargetIllustration: () => import('./TargetIllustration'),
  ProvidersIllustration: () => import('./ProvidersIllustration'),
  CalendarAvailableIllustration: () => import('./CalendarAvailableIllustration'),
  ProviderCalendarIllustration: () => import('./ProviderCalendarIllustration'),
  ProviderCalendarCheckmarkIllustration: () => import('./ProviderCalendarCheckmarkIllustration'),
  ProviderCalendarPreview: () => import('./ProviderCalendarPreview'),
  SessionsValuePropSpotIllustration: () => import('./SessionsValuePropSpotIllustration'),
  SelfCareValuePropSpotIllustration: () => import('./SelfCareValuePropSpotIllustration'),
  CareNavigatorValuePropSpotIllustration: () => import('./CareNavigatorValuePropSpotIllustration'),
  IntelligentMatchingValuePropSpotIllustration: () => import('./IntelligentMatchingValuePropSpotIllustration'),
  HandAndKeyIllustration: () => import('./HandAndKeyIllustration'),
  ProviderNoCapacityIllustration: () => import('./ProviderNoCapacityIllustration'),
  LyraSelectSelfCareValueSpotIllustration: () => import('./LyraSelectSelfCareValueSpotIllustration'),
  LyraSelectPersonalizedCareIllustration: () => import('./LyraSelectPersonalizedCareIllustration'),
  LyraSelectCareSessionIllustration: () => import('./LyraSelectCareSessionIllustration'),
  WellnessToolkitFooterLyraSelectIllustration: () => import('./WellnessToolkitFooterLyraSelectIllustration'),
  WellnessToolkitCoverIllustration: () => import('./WellnessToolkitCoverIllustration'),
  WellnessCheckInBenefitIllustration: () => import('./WellnessCheckInBenefitIllustration'),
  ExploreOnYourOwnIllustration: () => import('./ExploreOnYourOwnIllustration'),
  CareNavigatorCharacterSpotIcon: () => import('./CareNavigatorCharacterSpotIcon'),
  LyraSelectCareNavigatorValuePropSpotIllustration: () => import('./LyraSelectCareNavigatorValuePropSpotIllustration'),
  AvailabilityMatchIllustration: () => import('./AvailabilityMatchIllustration'),
  MagnifyingGlassIcon: () => import('./MagnifyingGlassIcon'),
  MeetWithAProviderIllustration: () => import('./MeetWithAProviderIllustration'),
  ChildTherapySecondaryRec: () => import('./ChildTherapySecondaryRec'),
  CheckEmailReminderIllustration: () => import('./CheckEmailReminderIllustration'),
  OnsiteProvidersSearchIllustration: () => import('./OnsiteProvidersSearchIllustration'),
  GooglePerformanceIllustration: () => import('./GooglePerformanceIllustration'),
  LaptopIllustration: () => import('./LaptopIllustration'),
  ProfileSelectionIllustration: () => import('./ProfileSelectionIllustration'),
  SelfCareIllustrationSvg: () => import('./SelfCareIllustrationSvg'),
  MeetWithAProviderIllustrationSvg: () => import('./MeetWithAProviderIllustrationSvg'),
  ContactCareNavigatorIllustration: () => import('./ContactCareNavigatorIllustration'),
  NeurodiversityCOEIllustration: () => import('./NeurodiversityCOEIllustration'),
  HealthChallengesCOEIllustration: () => import('./HealthChallengesCOEIllustration'),
  UnreadMessageIllustration: () => import('./UnreadMessageIllustration'),
  CriticalIncidentSupportIllustration: () => import('./CriticalIncidentSupportIllustration'),
  CaregivingIllustration: () => import('./womensHealthToolkitIllustrations/CaregivingIllustration'),
  FertilityIllustration: () => import('./womensHealthToolkitIllustrations/FertilityIllustration'),
  MenopauseIllustration: () => import('./womensHealthToolkitIllustrations/MenopauseIllustration'),
  MentalHealthLoadIllustration: () => import('./womensHealthToolkitIllustrations/MentalHealthLoadIllustration'),
  OtherTopicsIllustration: () => import('./womensHealthToolkitIllustrations/OtherTopicsIllustration'),
  PregnancyIllustration: () => import('./womensHealthToolkitIllustrations/PregnancyIllustration'),
  PremenstralDistressIllustration: () => import('./womensHealthToolkitIllustrations/PremenstralDistressIllustration'),
  SelfEsteemIllustration: () => import('./womensHealthToolkitIllustrations/SelfEsteemIllustration'),
  WomensHealthBenefitsIllustration: () => import('./womensHealthToolkitIllustrations/WomensHealthBenefitsIllustration'),
  ConfirmationCheckIllustration: () => import('./ConfirmationCheckIllustration'),
  OrbIllustration: () => import('./OrbIllustration'),
  BodyImageIcon: () => import('./healthChallengesIllustrations'),
  SleepIssuesIcon: () => import('./healthChallengesIllustrations'),
  CancerSurvivorshipIcon: () => import('./healthChallengesIllustrations'),
  ChronicPainIcon: () => import('./healthChallengesIllustrations'),
  OtherHealthConditionsIcon: () => import('./healthChallengesIllustrations'),
  NicotineQuitlineBenefitIllustration: () => import('./benefitSvgs'),
  ResourceCoordinationBenefitIllustration: () => import('./benefitSvgs'),
  WorkLifeServicesBenefitIllustration: () => import('./benefitSvgs'),
  AuroraWellnessCheckInBenefitIllustration: () => import('./benefitSvgs'),
  TraumaCheckInBenefitIllustration: () => import('./benefitSvgs'),
  MobileAppBenefitIllustration: () => import('./benefitSvgs'),
  HandHeartIllustration: () => import('./HandHeartIllustration'),
}
